// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '@/assets/css/reset.css'
import 'vant/lib/index.css'
import App from './App'
import router from './router'
import store from './store'
import fastClick from 'fastclick'
import Vant from 'vant'

import 'amfe-flexible/index.js'
import goBack from './utils/goBack'
import foot from '@/components/foot/index.js'
Vue.prototype.$back = goBack
Vue.use(Vant)
Vue.use(foot)

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 三利电子'
  } else {
    document.title = '三利电子'
  }

  let isLogin = Boolean(store.getters.token)
  if (to.meta.needLogin) {
    if (isLogin) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

Vue.config.productionTip = false
fastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js